import { Provider } from "react-redux";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoList from "./components/TodoList";
import store from "./redux/store";

function App() {
	return (
		<Provider store={store}>
			<div className="bg-blue-100 h-screen">
				<div className="grid place-items-center  px-6 font-sans">
					<Navbar />

					<div className="w-full mt-[100px] max-w-3xl shadow-lg rounded-lg p-6 bg-white">
						<Header />

						<hr className="mt-4" />

						<TodoList />

						<hr className="mt-4" />

						<Footer />
					</div>
				</div>
			</div>
		</Provider>
	);
}

export default App;
